import { SMART_ON_FHIR_LUNCH_TIME } from '../../utils/consts';

export const isPartOfEPICLoginFlow = (): boolean => Boolean(localStorage.getItem(SMART_ON_FHIR_LUNCH_TIME));
